import Vue from 'vue'
import axios from './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'

import '@/assets/css/animate.css';
//import '@/assets/css/bulma.css';
import Buefy from 'buefy';
import '@/scss/bulma_config.scss';
//import 'buefy/dist/buefy.css';



const ruMonthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
const ruDayNames =['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
const dialogConfirmText = "Ок"
const dialogCancelText = "Отмена"
const snackbarDuration = 2000


Vue.use(Buefy, {
 defaultIconPack: 'fas',
 defaultContainerElement: '#content',
 defaultMonthNames: ruMonthNames, defaultDayNames: ruDayNames, defaultFirstDayOfWeek: 1,
 defaultDialogConfirmText: dialogConfirmText,
 defaultDialogCancelText: dialogCancelText,
 defaultSnackbarDuration: snackbarDuration
});

//import simpleDialog from '@/components/dialogs/simpleDialog'
//Vue.components('Dialog', simpleDialog)

//import VModal from 'vue-js-modal'
//Vue.use(VModal)

//import '@/assets/css/normalize.css';

//import '@/assets/css/fontawesome/css/all.css';

Vue.config.productionTip = false
Vue.prototype.$locale = 'ru'
Vue.prototype.$appName = 'Сметные инструменты'
Vue.prototype.$appTitle = 'Сметные инструменты'
Vue.prototype.$appVersion = '0.1.0'
Vue.prototype.$http = axios;
Vue.prototype.$_ = lodash;
Vue.prototype.$projectStorage = window.localStorage;
//Vue.prototype.$dialog = dialog;

//components: {simpleDialog},

window.application = new Vue({
  name: 'mainApp',
  router,
  axios,
  store,
  render: h => h(App)
}).$mount('#app')


// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}